import { useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Grid, GridItem } from '@optimus-web/core';
import { ProductChecklistStatisticsResult } from '@mews-commander/data-access';
import { ProgressChartCard } from '@mews/b2b-ui';
import { useProductCheckListFiltersContext } from '../../contexts/ProductCheckListFiltersContext';
import { ProductCheckListDataTestIds } from '../../constants';
import { useClaimedByAgeChartDataCategories } from './useClaimedByAgeChartDataCategories';
import { useClaimedByHourChartDataCategories } from './useClaimedByHourChartDataCategories';

export const ProductCheckListStatisticsBody: React.FC<{ data: ProductChecklistStatisticsResult }> = ({ data }) => {
    const localizeText = useLocalizeText();
    const { filters } = useProductCheckListFiltersContext();

    const claimedByAgeChartDataCategories = useClaimedByAgeChartDataCategories(data);

    const claimedByHourChartDataCategories = useClaimedByHourChartDataCategories(data.statisticsData.claimedByHour);

    return (
        <Grid
            gap="200"
            templateColumns={claimedByAgeChartDataCategories.length > 1 ? '2fr 1fr' : '1fr 1fr'}
            tabletOnly={{ templateColumns: '1fr 1fr' }}
            largePhoneMax={{ templateColumns: '1fr' }}
        >
            {!!claimedByAgeChartDataCategories.length && (
                <GridItem overflow="hidden">
                    <ProgressChartCard
                        data-test-id={ProductCheckListDataTestIds.productsClaimedByAge}
                        charts={claimedByAgeChartDataCategories}
                        id={`${filters.date}-claimed-by-age`}
                        title={localizeText({ textKey: TextKey.ProductsClaimedByAge })}
                        columns={{
                            desktop: claimedByAgeChartDataCategories.length,
                            tablet:
                                claimedByAgeChartDataCategories.length > 3 ? 2 : claimedByAgeChartDataCategories.length,
                            phone: 1,
                        }}
                    />
                </GridItem>
            )}

            {!!claimedByHourChartDataCategories.length && (
                <GridItem overflow="hidden">
                    <ProgressChartCard
                        data-test-id={ProductCheckListDataTestIds.productsClaimedByHour}
                        charts={claimedByHourChartDataCategories}
                        id={`${filters.date}-claimed-by-hour`}
                        title={localizeText({ textKey: TextKey.ProductsClaimedByHour })}
                    />
                </GridItem>
            )}
        </Grid>
    );
};
